import * as React from "react";
import type { SVGProps } from "react";
const Farm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4362_7504)">
      <g clipPath="url(#clip1_4362_7504)">
        <path
          fill="currentColor"
          d="M4.6 4.7994c0-1.3237 1.0763-2.4 2.4-2.4h3.9862a2.396 2.396 0 0 1 2.2276 1.5075l1.8 4.4925H19V7.132c0-.93.2175-1.8487.6338-2.685l.0937-.1875c.2963-.5925 1.0162-.8325 1.6088-.5362s.8325 1.0162.5362 1.6087l-.0938.1875c-.2512.4988-.3787 1.05-.3787 1.6088v1.2675h2.1c.8288 0 1.5.6712 1.5 1.5v1.7025a1.799 1.799 0 0 1-.8475 1.5262l-1.6238 1.0163a4.5 4.5 0 0 0-1.7287-.345c-1.4737 0-2.7788.7087-3.6 1.8h-3c0 .6637-.5362 1.2-1.2 1.2h-.3075c-.0638.18-.1387.3562-.2175.5287l.2175.2175c.4688.4688.4688 1.23 0 1.6988l-.8475.8475c-.4687.4687-1.23.4687-1.6988 0l-.2174-.2175a5.4 5.4 0 0 1-.5288.2175v.3075c0 .6637-.5363 1.2-1.2 1.2H7c-.6638 0-1.2-.5363-1.2-1.2v-.3075c-.18-.0638-.3563-.1388-.5287-.2175l-.2176.2175c-.4687.4687-1.23.4687-1.6987 0l-.8475-.8475c-.4687-.4688-.4687-1.23 0-1.6988l.2175-.2175a5.4 5.4 0 0 1-.2175-.5287l-.3075.0037c-.6638 0-1.2-.5362-1.2-1.2v-1.2c0-.6637.5362-1.2 1.2-1.2h.3075c.0638-.18.1388-.3562.2175-.5287l-.2175-.2175c-.4687-.4688-.4687-1.23 0-1.6988l.8475-.8475a1.195 1.195 0 0 1 1.2413-.285V4.7994zm6.3862 0H7v3.6h5.4263zm-3.3862 7.2a3 3 0 1 0 0 6.0001 3 3 0 0 0 0-6.0001m13.2 7.2a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8m0 2.4c-1.8225 0-3.3-1.4775-3.3-3.3 0-1.1175.555-2.1037 1.4025-2.7a3.28 3.28 0 0 1 1.8975-.6c.1013 0 .1988.0038.2963.0113 1.6837.15 3.0037 1.5637 3.0037 3.2887 0 1.8225-1.4775 3.3-3.3 3.3"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4362_7504">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="clip1_4362_7504">
        <path fill="transparent" d="M1 2.3999h24v19.2H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default Farm;
